import React from "react";
import { FaUsers, FaHandshake } from "react-icons/fa";
import image1 from "../Images/image1.jpeg";
import { useNavigate } from "react-router-dom";

const WhyChooseUs = () => {
   const navigate = useNavigate();
  return (
    <section className="py-5">
      <div className="container">
        <div className="row align-items-center">

          {/* LEFT IMAGE */}
          <div className="col-lg-6 position-relative mb-5 mb-lg-0">
            <img
              src={image1}
              className="img-fluid rounded-4 w-100"
              alt="Pump Motor"
            />
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-lg-6 ps-lg-5">

            {/* WHY CHOOSE US ARROW + TEXT */}
            <div className="d-flex align-items-center mb-2">
              <span
                style={{
                  width: "30px",
                  height: "3px",
                  backgroundColor: "#224b8f",
                  marginRight: "10px",
                }}
              ></span>
              <span
                className="fw-semibold"
                style={{ color: "#224b8f" }}
              >
                WHY CHOOSE US?
              </span>
            </div>

            <h2 className="fw-bold mb-3">
              High-quality pumps and motors for every industrial and home need.
            </h2>

            <p className="text-muted mb-4">
              We specialize in supplying reliable, energy-efficient pumps and
              motors designed for long-lasting performance. Our products are
              trusted by homeowners, businesses, and industries for consistent
              and powerful results.
            </p>

            {/* FEATURE 1 */}
            <div className="d-flex mb-4">
              <div
                className="rounded-3 d-flex align-items-center justify-content-center me-3"
                style={{
                  width: "48px",
                  height: "48px",
                  backgroundColor: "#e8eef8",
                  color: "#224b8f",
                }}
              >
                <FaUsers size={20} />
              </div>
              <div>
                <h5 className="fw-bold mb-1">
                  Wide Range of Pumps & Motors
                </h5>
                <p className="text-muted mb-0">
                  From domestic water pumps to heavy-duty industrial motors,
                  we offer solutions for every application.
                </p>
              </div>
            </div>

            {/* FEATURE 2 */}
            <div className="d-flex mb-4">
              <div
                className="rounded-3 d-flex align-items-center justify-content-center me-3"
                style={{
                  width: "48px",
                  height: "48px",
                  backgroundColor: "#e8eef8",
                  color: "#224b8f",
                }}
              >
                <FaHandshake size={20} />
              </div>
              <div>
                <h5 className="fw-bold mb-1">
                  Trusted Quality & Expert Support
                </h5>
                <p className="text-muted mb-0">
                  We help you choose the right pump or motor with expert
                  guidance and dependable after-sales support.
                </p>
              </div>
            </div>

            {/* BUTTON */}
            <button
              className="btn px-4 py-2 rounded-pill text-white"
              style={{ backgroundColor: "#224b8f" }}
               onClick={() => navigate("/product")}
            >
              VIEW OUR PRODUCTS
            </button>

          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
